import { render, staticRenderFns } from "./TypeBotBubble.vue?vue&type=template&id=aa1f1412&scoped=true&"
import script from "./TypeBotBubble.vue?vue&type=script&lang=js&"
export * from "./TypeBotBubble.vue?vue&type=script&lang=js&"
import style0 from "./TypeBotBubble.vue?vue&type=style&index=0&id=aa1f1412&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aa1f1412",
  null
  
)

export default component.exports